<div class="mx-auto w-full md:w-4/5">
  <yr-edit-collection></yr-edit-collection>
</div>
